import type { BuilderState } from "./builderTypes.js";
import { policyModeDescription, policyModeLabel } from "../../lib/policyPresentation.js";

type PolicyModeCardsProps = {
  value: BuilderState["mode"];
  onChange: (mode: BuilderState["mode"]) => void;
  disabled?: boolean;
};

const modes: BuilderState["mode"][] = ["conditional", "allow", "deny", "require_approval"];

export const PolicyModeCards = ({ value, onChange, disabled = false }: PolicyModeCardsProps) => (
  <div className="admin-policy-mode-grid" role="radiogroup" aria-label="Policy mode">
    {modes.map((mode) => (
      <button
        key={mode}
        type="button"
        role="radio"
        aria-checked={value === mode}
        disabled={disabled}
        className={`admin-policy-mode-card${value === mode ? " admin-policy-mode-card-active" : ""}`}
        onClick={() => onChange(mode)}
      >
        <span className="admin-policy-mode-card-label">{policyModeLabel[mode]}</span>
        <span className="admin-policy-mode-card-desc">{policyModeDescription[mode]}</span>
      </button>
    ))}
  </div>
);
